import React from "react";
import { Building2 } from "lucide-react";
import { useOutlets } from "./OutletContext";

const TYPE_LABEL = {
  restaurant: "Restaurant",
  bar: "Bar",
  hotel: "Hotel",
  cafe: "Café",
  catering: "Catering",
  other: "Sonstiges",
};

export default function OutletBreadcrumb() {
  const { activeOutlet } = useOutlets();
  if (!activeOutlet) return null;
  return (
    <div className="hidden md:inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full border border-brand/20 bg-brand/[0.05] text-[11px] text-brand" data-testid="outlet-breadcrumb">
      <Building2 size={11} />
      <span className="font-medium">{activeOutlet.name}</span>
      <span className="opacity-60">·</span>
      <span className="opacity-80">{TYPE_LABEL[activeOutlet.type] || activeOutlet.type}</span>
    </div>
  );
}
